import {baseUrl, buildAuthRequest, handleJsonResponse} from "./util/Common";

function findPipes(hubId) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}/pipes`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function findPipeById(hubId, pipeId) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}/pipes/${pipeId}`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function updatePipeById(hubId,
                        pipeId,
                        {
                            title = undefined,
                            status = undefined,
                            period = undefined,
                            actions = undefined,
                            metrics = undefined,
                            settings = undefined,
                            metadata = undefined
                        }) {
    return buildAuthRequest(
        'PATCH',
        {'Content-Type': 'application/json'},
        JSON.stringify({
            title: title,
            status: status,
            period: period,
            actions: actions,
            metrics: metrics,
            settings: settings,
            metadata: metadata
        })
    ).then((req) => {
        return fetch(`${baseUrl}/hubs/${hubId}/pipes/${pipeId}`, req);
    }).then((res) => {
        return handleJsonResponse(res);
    });
}

export {
    findPipes,
    findPipeById,
    updatePipeById
}